/**
 * useSmartHomeWS — subscribe to topic 'smarthome' and invalidate the status
 * query (Wave 1). Mirror of useCalendarWS.
 *
 * The server's refreshSmartHome job broadcasts { topic:'smarthome',
 * event:'status', data:{ total, on } } only when the light tally changes, so
 * dashboards re-render promptly without each client polling the bridge. We keep
 * the cache authoritative and just invalidate (no direct patch) so the next
 * read goes through the service's aggregation + circuit breaker.
 *
 * Gjenoppkobling og backoff: se lib/reconnectingSocket.ts.
 */
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { openReconnectingSocket } from '../../lib/reconnectingSocket';

export function useSmartHomeWS(): void {
  const qc = useQueryClient();

  useEffect(() => {
    const onMessage = (ev: unknown) => {
      try {
        const data = (ev as { data?: unknown }).data;
        const msg = JSON.parse(String(data)) as { topic?: string; event?: string };
        if (msg?.topic !== 'smarthome') return;
        if (msg.event === 'status') {
          void qc.invalidateQueries({ queryKey: ['smarthome'] });
        }
      } catch {
        // Malformed frame — drop silently.
      }
    };

    return openReconnectingSocket({ topics: ['smarthome'], onMessage });
  }, [qc]);
}
